// extracted by css-extract-rspack-plugin
export default {"screenshot":"screenshot-G2piI7"};